export const usaEmailCliente =
  String(process.env.VUE_APP_USA_EMAIL_CLIENTE ?? "TRUE").toUpperCase() ===
  "TRUE";
